import React from 'react'

export default ({ loginUrl, loginText, disabled }) => {
  if (disabled) {
    return undefined
  }
  return (
    <a href={loginUrl}>
      <button disabled={disabled} type="button" className="btn theme-button-primary w-100">
        {__.trans(loginText)}
      </button>
    </a>
  )
}
